export const OPTIMIZELY_ID_ATTR = 'optimizely-id';
